// extracted by mini-css-extract-plugin
module.exports = {"Wrap":"PlansLegend_Wrap__18RYa","Item":"PlansLegend_Item__UyEAn","Dot0":"PlansLegend_Dot0__1ktil","Dot1":"PlansLegend_Dot1__2heLu","Dot2":"PlansLegend_Dot2__1dGvw"};